import { useActiveOrganizationListener } from 'hooks/useActiveOrganizationListener';
import {
  useEditableCard,
  CardGridLayout,
  GridInput
} from 'lib/components/Card/Grid';
import { ColumnSelect } from 'lib/components/ColumnSelect';
import { Form } from 'lib/components/Form';
import { TextField } from 'lib/components/TextField';
import { TimezoneType } from 'lib/enums';
import { removeUndefinedFields } from 'lib/helpers';
import { MAX_ORGANIZATION_NAME_LENGTH } from 'lib/types/organization';
import { useAppDispatch } from 'redux/hooks';
import ToastActions from 'redux/toast';

export default function HoldingCompanyInfo() {
  const dispatch = useAppDispatch();
  const activeOrganization = useActiveOrganizationListener();

  const { name, phone, iana_timezone } = activeOrganization?.data() ?? {};

  const { formSettings, onChange, disabled, editable, onSubmitWrapper } =
    useEditableCard({
      name,
      phone,
      iana_timezone
    });

  return (
    <Form
      id="holding-company-settings-info"
      onSubmit={() =>
        onSubmitWrapper(async () => {
          await activeOrganization?.ref.update(
            removeUndefinedFields(formSettings)
          );
          dispatch(
            ToastActions.toastSuccess({
              headerText: 'Success',
              bodyText: 'Organization settings updated successfully.'
            })
          );
          return { success: true };
        })
      }
    >
      <CardGridLayout
        header={{ title: 'General Information' }}
        editable={editable}
      >
        <GridInput>
          <TextField
            labelText="Organization name"
            required
            onChange={name => onChange({ name })}
            value={formSettings.name}
            disabled={disabled}
            maxLength={MAX_ORGANIZATION_NAME_LENGTH}
            id="name"
          />
        </GridInput>
        <GridInput>
          <TextField
            labelText="Phone number"
            required
            onChange={phone => onChange({ phone })}
            value={formSettings.phone}
            disabled={disabled}
            type="tel"
            id="phone"
          />
        </GridInput>
        <GridInput>
          <ColumnSelect
            labelText="Timezone"
            size="md"
            options={TimezoneType.items().map(tz => ({
              value: tz.key,
              label: tz.label
            }))}
            onChange={iana_timezone => onChange({ iana_timezone })}
            value={formSettings.iana_timezone || ''}
            disabled={disabled}
            id="timezone"
          />
        </GridInput>
      </CardGridLayout>
    </Form>
  );
}
